import React from "react";
import { useTranslation } from "react-i18next";

import {
  useRetrieveCurrentPlanzone,
  useRetrieveProjectModels,
} from "@planzone/view-models";
import { Loader } from "@common/loader";
import { CloseIcon } from "@common/assets/closeIcon";
import { Props } from "./types";
import { ProjectModel } from "./projectModel";
import styles from "./styles.scss";

function ModelSelection({ selectModel, close }: Props) {
  const { t } = useTranslation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    projectModels,
    retrieveProjectModels,
  } = useRetrieveProjectModels();

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveProjectModels(planzone);
  }, []);

  return (
    <div className={styles.projectModel}>
      <div className={styles.header}>
        <h1 className={styles.title}>{t("projectCreationFromModel.title")}</h1>
        <div onClick={close} className={styles.removeIconBox}>
          <CloseIcon className={styles.removeIcon} />
        </div>
      </div>
      {isRequestPending && (
        <div className={styles.loader}>
          <div className={styles.loaderMain}>
            <Loader />
          </div>
        </div>
      )}
      <div className={styles.main}>
        <h3 className={styles.subTitle}>
          {t("projectCreationFromModel.subTitle")}
        </h3>
        <p className={styles.description}>
          {t("projectCreationFromModel.description")}
        </p>
        <div className={styles.list}>
          {[...projectModels]
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((model) => (
              <ProjectModel
                projectModel={model}
                select={() => selectModel(model)}
              />
            ))}
        </div>
        <div className={styles.buttons}>
          <button className={styles.cancelButton} type="button" onClick={close}>
            {t("projectCreationFromModel.cancel")}
          </button>
        </div>
      </div>
    </div>
  );
}

export { ModelSelection };
